const accountpageText = {
  offersToMe: "Teklif Aldıklarım",
  myOffers: "Teklif Verdiklerim",
  noProducts: "Mevcut bir teklifiniz bulunmuyor.",
  noOffers: "Ürünlerinizde aktif bir teklif bulunmuyor.",
  offer: "Alınan Teklif: ",
  offerTo: "Verilen Teklif: ",
  approve: "Onayla",
  refuse: "Reddet",
  sold: "Satıldı",
  approved: "Onaylandı",
  refused: "Reddedildi",
  bought: "Satın Alındı",
  buy: "Satın Al",
};

export default accountpageText;
